<template>
  <div>
    <common-dialog
      ref="dialog"
      title="Modify Group"
      :width="40"
      :inputs-map="inputsMap"
      :input-value-change="valueChange"
      :save-cb="save"
      :reset-inputs="resetInputs"
    >
      <template v-slot:buttons>
        <div class="extra-btns f-r">
          <div class="op confirm" @click="addAddress" v-if="!hasAddress">
            <svg-icon
              icon-class="plus"
              style="font-size: 23px;"
              class="svg-business-color"
            />
            <span>Add Address</span>
          </div>
        </div>
      </template>
    </common-dialog>
    <address-new ref="newAddress"></address-new>
  </div>
</template>
<script>
// others
import cloneDeep from 'lodash/cloneDeep'
import get from 'lodash/get'
// models
import { GoodsGroupModifyForm } from '@/core/models/job'
// mixin
import { dialogMixin } from '@/core/mixin/dialog'
// components
import CommonDialog from '@/components/common/CommonDialog.vue'
import AddressNew from '@/components/address/AddressNew.vue'
import { modifyGoodsGroup } from '@/api/job'
// msg
import PagesMessage from '@/core/message/pages'
export default {
  name: 'GoodsGroupModify',
  mixins: [dialogMixin],
  components: {
    CommonDialog,
    AddressNew
  },
  props: {
    jobId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      inputsMap: cloneDeep(GoodsGroupModifyForm),
      originGroup: null
    }
  },
  computed: {
    hasAddress() {
      const addressInfo = this.inputsMap.find(g => g.key === 'address')
      return !!addressInfo.value
    }
  },
  methods: {
    save(info, done, error) {
      if (info.address) info.addressId = info.address.id
      modifyGoodsGroup(this.jobId, this.originGroup.name, info)
        .then(res => {
          this.$message.success('Modify goods group successfully!')
          this.close()
          PagesMessage.emit(PagesMessage.eventMap.REFRESH_JOB_DETAIL)
          done()
        })
        .catch(err => {
          error(err)
        })
      return [false, '']
    },
    open(group) {
      this.originGroup = group
      this.resetInputs()
      this.$refs.dialog.open()
    },
    close() {
      this.originGroup = null
      this.$refs.dialog.close()
    },
    resetInputs() {
      this.inputsMap.forEach(one => {
        one.value = get(this.originGroup, one.key, '')
      })
    },
    valueChange() {},
    addAddress() {
      this.$refs.newAddress.open()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.op {
  gap: 5px;

  &:hover {
    cursor: pointer;
  }

  @extend .f-r-vc;

  span {
    font-size: $title-level-regular;
  }

  .op-icon {
    font-size: $dialog-header-op-icon-size;
  }
}
</style>
